<template>
  <div>
    <div
      class="flex min-h-[56px] flex-row items-center gap-sm bg-surface-2 px-md py-sm text-on-surface dark:bg-surface-2-dark dark:text-on-surface-dark typography-caption-regular hover:bg-primary-opacity-0-08 dark:hover:bg-primary-opacity-0-08-dark"
      :class="{
        'rounded-sm': isRounded,
        'rounded-b-none': showToggle && isOpened,
      }"
      data-test="version-item"
      @click="openInNewTab"
    >
      <OrIconButtonV3
        v-if="showToggle"
        :icon="isOpened ? 'expand_more' : 'chevron_right'"
        data-test="card-content"
        @click.stop="emit('toggleVersions')"
      />
      <div
        class="flex flex-row items-center gap-sm min-w-0 grow"
      >
        <OrIconV3
          v-if="showLeadingIcon && !showToggle"
          icon="subdirectory_arrow_right"
        />
        <span>{{ $t('version') }}</span>
        <span
          class="typography-caption-bold grow truncate"
        >{{ version }}</span>
      </div>
      <div class="flex items-center gap-sm shrink-0">
        <span v-if="isLatest && !showToggle">{{ $t('latest') }}</span>
        <div class="actions flex gap-xs">
          <OrTooltipV3
            :text="$t('openInNewTab')"
            placement="top"
          >
            <OrIconButtonV3
              icon="open_in_new"
              data-test="open-in-new-tab"
              @click.stop="openInNewTab"
            />
          </OrTooltipV3>
          <OrTooltipV3
            v-if="showDelete && !isLatest"
            :text="$t('delete')"
            placement="top"
          >
            <OrIconButtonV3
              icon="delete"
              data-test="delete-version"
              @click.stop="emit('versionDelete', version)"
            />
          </OrTooltipV3>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { OrIconV3, OrIconButtonV3, OrTooltipV3 } from '@onereach/ui-components';
import { getDocsUrl } from '@/utils/docsUrl';

const props = withDefaults(defineProps<{
  version?: string;
  projectName: string;
  isLatest?: boolean;
  showToggle?: boolean;
  showDelete?: boolean;
  showLeadingIcon?: boolean;
  isRounded?: boolean;
  isOpened?: boolean;
}>(), {
  version: '',
  isLatest: false,
  showToggle: false,
  showDelete: true,
  showLeadingIcon: true,
  isRounded: true,
  isOpened: false,
});

const emit = defineEmits<{
  (event: 'versionDelete', version: string): void;
  (event: 'toggleVersions'): void;
}>();

const docsUrl = computed(() => props.version ? getDocsUrl(props.projectName, props.version) : '');

function openInNewTab() {
  if (docsUrl.value) {
    window.open(docsUrl.value, '_blank', 'noopener,noreferrer');
  }
}
</script>
